import { render, staticRenderFns } from "./AppointmentManagement.vue?vue&type=template&id=b9dbbc22&scoped=true"
import script from "./AppointmentManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentManagement.vue?vue&type=script&lang=js"
import style0 from "./AppointmentManagement.vue?vue&type=style&index=0&id=b9dbbc22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dbbc22",
  null
  
)

export default component.exports